import Panel from '@admin/components/panel'
import AppToken from '@admin/tokens/app'

const mapPropsToPanel = (props, context) => ({
  title: 't(Apps)',
  collection: {
    endpoint: '/api/admin/platform/apps',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(App)', key: 'code', primary: true, format: AppToken }
    ],
    defaultSort: { key: 'code', order: 'asc' },
    entity: 'app',
    onClick: (record) => context.router.push(`/platform/apps/${record.code}`)
  }
})

export default Panel(null, mapPropsToPanel)
